var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mb-4",attrs:{"value":_vm.shop.enabled,"color":"warning","icon":"priority_high","outline":""}},[_vm._v(" Please, disable shop and save to edit listings! ")])}
var staticRenderFns = []

export { render, staticRenderFns }